module.exports = __webpack_public_path__ + "img/Urban_Outfitters_logo.9a00e29f.png";